import { useContext, useEffect, useState } from 'react';
import './donneesClient.scss';
import AppelerApi from '../../../services/appeler-api.service';
import { Snackbar, TextField, Checkbox, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip, Divider, Modal, Box, Tab, Tabs, TextareaAutosize } from '@mui/material';
import ChoisirIcone from '@mui/icons-material/Input';
import ValideIcone from '@mui/icons-material/Check';
import InvalideIcone from '@mui/icons-material/Block';
import TelephoneIcone from '@mui/icons-material/PhoneInTalk';
import EmailIcone from '@mui/icons-material/Mail';
import AjouterIcone from '@mui/icons-material/AddBox';
import SupprimerIcone from '@mui/icons-material/Delete';
import AnnulerIcone from '@mui/icons-material/Replay';
import SelectPays, {PAYS} from '../../Composants/selectPays/selectPays';
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { baseSelectionneeContext } from '../../../App';
import { useCallback } from 'react';

const couleurStatut = {
    'A FAIRE': 'white',
    'Dev en cours': '#86BDFF',
    'Recette': '#86BDFF',
    'En attente': '#C0C0C0',
    'Go pour MEP': '#86BDFF',
    'Prod OK': '#B3DF72',
    'Annulé': 'white',
    'SUPPORT NIV. 1': '#C0C0C0',
    'N1 en cours': '#86BDFF',
    'SUPPORT NIV. 2': '#C0C0C0',
    'N2 EN COURS': '#86BDFF',
    'En cours (Link)': '#86BDFF',
    'En attente Po (VÉRIFICATION)': '#C0C0C0',
    'En attente de dev': '#C0C0C0',
    'En cours...': '#86BDFF',
    'Prêt à prédéployer': '#B3DF72',
    'En prédéploiement': '#B3DF72',
    'INFORMER LE CLIENT': '#B3DF72',
    'Résolue': '#B3DF72',
};

const bordureStatut = {
    'A FAIRE': 'solid 1px black',
    'Dev en cours': 'unset',
    'Recette': 'solid 1px black',
    'En attente': 'solid 1px black',
    'Go pour MEP': 'solid 1px black',
    'Prod OK': 'unset',
    'Annulé': 'solid 1px red',
    'SUPPORT NIV. 1': 'solid 1px black',
    'N1 en cours': 'unset',
    'SUPPORT NIV. 2': 'solid 1px black',
    'N2 EN COURS': 'solid 1px black',
    'En cours (Link)': 'unset',
    'En attente Po (VÉRIFICATION)': 'unset',
    'En attente de dev': 'solid 1px black',
    'En cours...': 'solid 1px black',
    'Prêt à prédéployer': 'unset',
    'En prédéploiement': 'unset',
    'INFORMER LE CLIENT': 'solid 1px black',
    'Résolue': 'unset',
};

const DonneesClient = () => {
    const { baseSelectionnee } = useContext(baseSelectionneeContext);
    const [valeurEntree, _] = useState('');
    const [afficherEnregistrement, setAfficherEnregistrement] = useState(false);
    let [clients, setClients] = useState([]);
    let [groupes, setGroupes] = useState([]);
    let [client, setClient] = useState(null);
    let [ongletSelectionne, changerOnglet] = useState(0);
    let [parametres, setParametres] = useState({});
    let [listeRevendeurs, setRevendeurs] = useState([]);
    let [commentaires, setCommentaires] = useState([]);
    let [materiels, setMateriel] = useState([]);
    let [mapTypesMateriel, setMapTypesMateriel] = useState({});
    let [listeTypesMateriel, setListeTypesMateriel] = useState([]);
    const [supprimerMaterielOuvert, setSupprimerMaterielOuvert] = useState(null);
    const [supprimerCommentaireOuvert, setSupprimerCommentaireOuvert] = useState(null);
    let [revendeur, setRevendeur] = useState(listeRevendeurs[0]);
    const nouveauRevendeur = { value: -1, label: 'Nouveau revendeur' };
    const [nouveauRevendeurOuvert, setNouveauRevendeurOuvert] = useState(false);
    let [nomRevendeur, setNomRevendeur] = useState('');
    const [confirmationOuverte, setConfirmationOuverte] = useState(false);
    const [messageConfirmation, setMessageConfirmation] = useState('');
    const [actionValidation, setActionValidation] = useState(() => (() => {}));
    const [archivageEnCours, setArchivageEnCours] = useState(false);
    const [messageCopie, setMessageCopie] = useState('Copier dans le presse-papier');
    const [urlReservation, setUrlReservation] = useState('');
    const [urlReservationInvalide, setUrlReservationInvalide] = useState(false);
    const [nouveauClientOuvert, ouvrirNouveauClient] = useState(false);
    const [nouveauClient, modifierNouveauClient] = useState({ telephoneSalon: '', telephonePortable: '', adresseEmail: '', nomGerant: '', raisonSociale: '', adresse: '', codePostal: '', ville: '', pays: '1', codePays: 'FR', test: false, activite: 1, siret: '', tvaIntracom: '', codeNaf: '96.02A', migrationHN: false, statut: 2, referenceHubspot: '', referenceGomc: '', numeroMagasinGomc: '1' });
    const utilisateur = localStorage.getItem('utilisateur');
    let [encoursClient, setEncoursClient] = useState(null);
    let dateCourante = '';

    const listeCriteres = [{ value: 'LOGIN', label: 'Client par login' }, { value: 'IDFICCLIENT', label: 'Clients par ID Client / GOMC / Hubspot' },
        { value: 'TELEPHONE', label: 'Clients par téléphone' }, { value: 'RAISON_SOCIALE', label: 'Clients par raison sociale' },
        { value: 'NOM', label: 'Clients par nom du gérant' }, { value: 'EMAIL', label: 'Clients par adresse e-mail' },
        { value: 'VILLE', label: 'Clients par ville ou CP' }, { value: 'DEMO', label: 'Clients démo ou test' },
        { value: 'DANS_ADMIN', label: 'Clients ayant un admin' }, { value: 'GROUPE', label: 'Clients par groupe' },
        { value: 'SANS_WEBAPP', label: 'Clients sans webapp' },
    ];
    let [critere, setCritere] = useState(listeCriteres[0]);

    const listeMarques = [{ value: 1, label: 'LSCoiffure' }, { value: 2, label: 'LSInstitut' }, { value: 4, label: 'Hairnet+' }];
    let [marque, setMarque] = useState(listeMarques[0]);

    const listeStatuts = [{ value: 1, label: 'Prospect' }, { value: 2, label: 'Abo actif' }, { value: 3, label: 'Abo suspendu' }, { value: 4, label: 'Abo annulé' }, { value: 5, label: 'Achat licence' }, { value: 7, label: 'Test ou démo' }];
    let [statut, setStatut] = useState(listeStatuts[0]);
    let [statutNouveauClient, setStatutNouveauClient] = useState(listeStatuts[1]);

    const listeMetiers = [{ value: '96.02A', label: 'Coiffeur, barbier' }, { value: '96.02B', label: 'Institut de beauté, onglerie' }];
    let [metier, setMetier] = useState(listeMetiers[0]);
    let [metierNouveauClient, setMetierNouveauClient] = useState(listeMetiers[0]);

    const listeApplicationsHairconnect = [{ value: 0, label: 'Hairconnect (indé)' }, { value: 1, label: 'Mon Coiffeur (Hairbusiness)' }];
    let [applicationHairconnect, setApplicationHairconnect] = useState(listeApplicationsHairconnect[0]);

    const modifierCritere = (critere) => {
        setCritere(critere);
        chercherSalon(critere); // Pour critères sans filtre associé
        if (critere.value === 'GROUPE') {
            AppelerApi.get('/lire-groupes').then(data => {
                setGroupes(data.groupes.map(groupe => { return { value: groupe.IDGroupe, label: groupe.Nom } }));
            });
        }
    };

    const modifierMarque = (marque) => {
        parametres.marque = marque.value;
        setParametres({ ...parametres });
        setMarque(marque);
        modifierParametre('marque', marque.value)
    };

    const modifierStatut = (statut) => {
        parametres.statutAbonnement = statut.value;
        setParametres({ ...parametres });
        setStatut(statut);
        modifierParametre('statutAbonnement', statut.value)
    };

    const modifierMetier = (metier) => {
        parametres.codeNaf = metier.value;
        setParametres({ ...parametres });
        setMetier(metier);
        modifierParametre('codeNaf', metier.value);
    }

    const mettreEnFormeTelephone = (valeur) => { // Ce serait cool de mettre en forme aussi les numéros avec indicatifs, mais pas assez de caractères en BDD (pas changeable tant qu'il y a Hairport)
        if (!valeur) {
            return '';
        }
        let plusDebut = (valeur[0] === '+') ? valeur[0] : '';
        const telephone = valeur.replace(/\D/g, '');
        if (plusDebut !== '') {
            return plusDebut + telephone;
        }
        valeur = '';
        for (let i = 0; i < telephone.length; i++) {
            valeur += telephone[i];
            if (i % 2 === 1) {
                valeur += '.';
            }
        }
        if (valeur[valeur.length - 1] === '.') {
            valeur = valeur.substring(0, valeur.length - 1);
        }
        return valeur;
    };

    const modifierTelephone = (type, valeur) => {

        valeur = mettreEnFormeTelephone(valeur);

        modifierParametre(type, valeur);
    };

    const modifierRevendeur = (revendeur) => {
        if (revendeur.value === nouveauRevendeur.value) {
            setNomRevendeur('');
            setNouveauRevendeurOuvert(true);
            return;
        }
        parametres.IDRevendeur = revendeur.value;
        setParametres({ ...parametres });
        setRevendeur(revendeur);
        AppelerApi.post('/modifier-parametre-client', { idFicClient: client.idFicClient, enseigne: client.ID_Enseigne, champ: 'IDRevendeur', valeur: revendeur.value }).then(() => {
            setAfficherEnregistrement(true);
        });
    };

    const creerRevendeur = () => {
        AppelerApi.post('/creer-revendeur', { nomRevendeur }).then(revendeur => {
            setRevendeurs(listeRevendeurs.filter(rev => rev.value !== nouveauRevendeur.value).concat([revendeur, nouveauRevendeur]));
            modifierRevendeur(revendeur);
        });
        setNouveauRevendeurOuvert(false);
    };

    const modifierApplicationHairconnect = (app) => {
        parametres.Hairconnect_Groupe = app.value;
        setParametres({ ...parametres });
        setApplicationHairconnect(app);
        AppelerApi.post('/modifier-parametre-client', { idFicClient: client.idFicClient, enseigne: client.ID_Enseigne, champ: 'Hairconnect_Groupe', valeur: app.value }).then(() => {
            setAfficherEnregistrement(true);
        });
    };

    const rechercheParChaine = debounce((chaine, critereOptionnel) => {
        chercherSalon(critereOptionnel ?? critere, chaine);
    }, 500);

    const chercherSalon = (critere, valeurFiltre, clicAutomatique) => {
        switch (critere.value) {
            case 'LOGIN':
                if (!valeurFiltre || valeurFiltre.length < 3) {
                    return;
                }
                AppelerApi.get('/lire-clients-par-enseigne', { enseigne: valeurFiltre }).then(data => {
                    setClients(data.clients);
                });
                return;
            case 'DEMO':
                AppelerApi.get('/lire-clients-demo').then(data => {
                    setClients(data.clients);
                });
                return;
            case 'DANS_ADMIN':
                AppelerApi.get('/lire-clients-dans-admin').then(data => {
                    setClients(data.clients);
                });
                return;
            case 'SANS_WEBAPP':
                AppelerApi.get('/lire-clients-sans-webapp').then(data => {
                    setClients(data.clients);
                });
                return;
            case 'GROUPE':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-clients-par-groupe', { IDGroupe: valeurFiltre.value }).then(data => {
                    setClients(data.clients);
                });
                return;
            case 'IDFICCLIENT':
            case 'TELEPHONE':
            case 'NOM':
            case 'RAISON_SOCIALE':
            case 'EMAIL':
            case 'VILLE':
                if (!valeurFiltre || (valeurFiltre.length < 2 && critere.value !== 'IDFICCLIENT')) {
                    return;
                }
                AppelerApi.get('/lire-clients-par-critere', { critere: critere.value, valeur: valeurFiltre }).then(data => {
                    setClients(data.clients);
                    if (clicAutomatique && data.clients.length > 0) {
                        selectionnerClient(data.clients[0]);
                    }
                });
                return;
        }
    };

    const selectionnerClient = (client) => {
        setClient(client);
        setEncoursClient(null);
        AppelerApi.get('/lire-parametres-client', { idFicClient: client.idFicClient }).then(data => {
            data.periodeAbonnement = calculerPeriodeAbonnement(data.Jours_Totaux);
            data.dateDernierRDVAffiche = data.datedernierRDV ? `${data.datedernierRDV.substring(8, 10)}/${data.datedernierRDV.substring(5, 7)}/${data.datedernierRDV.substring(0, 4)}` : '';
            data.dateDerniereConnexionAffiche = data.dateDerniereConnexion ? `${data.dateDerniereConnexion.substring(8, 10)}/${data.dateDerniereConnexion.substring(5, 7)}/${data.dateDerniereConnexion.substring(0, 4)}` : '';
            const parametres = data;
            setParametres(data);
            const revendeur = listeRevendeurs.find(rev => rev.value === parametres.IDRevendeur);
            setRevendeur(revendeur ?? listeRevendeurs[0]);
            const marque = listeMarques.find(marque => marque.value === parametres.marque);
            setMarque(marque ?? listeMarques[0]);
            const statut = listeStatuts.find(statut => statut.value === parametres.statutAbonnement);
            setStatut(statut ?? listeStatuts[0]);
            const metier = listeMetiers.find(metier => metier.value === parametres.codeNaf);
            setMetier(metier ?? null);
            const app = listeApplicationsHairconnect.find(app => app.value === parametres.Hairconnect_Groupe);
            setApplicationHairconnect(app ?? listeApplicationsHairconnect[0]);
            if ((!!parametres.archive && parametres.ticketsPresents > 0) || (!parametres.archive && parametres.ticketsPresents === 0)) {
                setArchivageEnCours(true);
            } else {
                setArchivageEnCours(false);
            }
            if (!parametres.lsrendezvousurl || parametres.lsrendezvousurl === '') {
                if (parametres.codePostal && parametres.codePostal !== '') {
                    proposerUrlReservation(parametres.Raison_sociale + '-' + parametres.codePostal);
                } else {
                    proposerUrlReservation(parametres.Raison_sociale);
                }
            } else {
                setUrlReservation(parametres.lsrendezvousurl);
                setUrlReservationInvalide(false);
            }
            lireCommentairesAssistance(client);
            lireEncoursClient(client);
            lireMaterielClient(client);
        });
    };

    const lireCommentairesAssistance = (clientSelectionne) => {
        AppelerApi.get('/lire-commentaires-assistance', { idFicClient: clientSelectionne ? clientSelectionne.idFicClient : client.idFicClient }).then(data => {
            for (const commentaire of data) {
                commentaire.dateHeureAffichee = affichageDateHeure(commentaire.dateHeure);
                commentaire.dateAffichee = commentaire.dateHeureAffichee.substring(0, 10);
            }
            setCommentaires(data);
        });
    };

    const lireEncoursClient = (clientSelectionne) => {
        if (baseSelectionnee !== 'PROD') {
            return;
        }
        AppelerApi.get('/lire-encours-client', { idFicClient: clientSelectionne ? clientSelectionne.idFicClient : client.idFicClient }).then(data => {
            setEncoursClient(data.encours);
        });
    };

    const appliquerModificationParametre = useCallback(debounce((client, champ, valeur) => {
        AppelerApi.post('/modifier-parametre-client', { idFicClient: client.idFicClient, enseigne: client.ID_Enseigne, champ, valeur }).then(() => {
            setAfficherEnregistrement(true);
        });
    }, 700), []);

    const modifierParametre = (champ, valeur) => {
        parametres[champ] = valeur;
        setParametres({ ...parametres });
        if (champ === 'LSRDesactivation') { // à cause du debounce, le blocage de webapp ne prend pas en compte le blocage du site de résa
            AppelerApi.post('/modifier-parametre-client', { idFicClient: client.idFicClient, enseigne: client.ID_Enseigne, champ, valeur }).then(() => {
                setAfficherEnregistrement(true);
            });
        } else {
            appliquerModificationParametre(client, champ, valeur);
        }
    };

    const masquerEnregistrement = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAfficherEnregistrement(false);
    };

    const blocageWebApp = (valeur) => {
        const maintenant = formaterDate(new Date());
        if (valeur) {
            cloturerPeriodeAbonnement(maintenant);
            modifierParametre('LSRDesactivation', valeur);
        } else {
            creerPeriodeAbonnement(maintenant);
        }
        modifierParametre('bloquer', valeur);
    }

    const calculerPeriodeAbonnement = (joursTotaux) => {
        const debut = new Date();
        debut.setDate(debut.getDate() - joursTotaux);
        const fin = new Date();
    
        let annees = fin.getFullYear() - debut.getFullYear();
        let mois = fin.getMonth() - debut.getMonth();
        let jours = fin.getDate() - debut.getDate();
    
        if (jours < 0) {
            mois--;
            const dernierJourMoisPrecedent = new Date(fin.getFullYear(), fin.getMonth(), 0).getDate();
            jours += dernierJourMoisPrecedent;
        }
        if (mois < 0) {
            annees--;
            mois += 12;
        }
    
        const resultats = [];
        if (annees > 0) resultats.push(`${annees} an${annees > 1 ? 's' : ''}`);
        if (mois > 0) resultats.push(`${mois} mois`);
        if (jours > 0) resultats.push(`${jours} jour${jours > 1 ? 's' : ''}`);
    
        return resultats.length > 0 ? resultats.join(' ') : '0 jour';
    };

    const cloturerPeriodeAbonnement = (dateFin) => {
        AppelerApi.post('/cloturer-periode-abonnement', { enseigne: client.ID_Enseigne, dateFin }).then(() => {
            parametres.dateFin = dateFin;
            setParametres({ ...parametres });
        });
    }

    const creerPeriodeAbonnement = (valeur) => {
        AppelerApi.post('/creer-periode-abonnement', { enseigne: client.ID_Enseigne, idFicClient: parametres.idFicClient, valeur }).then((res) => {
            setParametres({ ...parametres });
        });
    }

    const appelerArchiver = () => {
        setMessageConfirmation(`Êtes-vous sûr de vouloir archiver le salon ${parametres.Raison_sociale} ?`);
        setActionValidation(() => archiver);
        setConfirmationOuverte(true);
    }

    const appelerDesarchiver = () => {
        setMessageConfirmation(`Êtes-vous sûr de vouloir désarchiver le salon ${parametres.Raison_sociale} ?\r\nN'oubliez pas de le réarchiver si vous n'en n'avez plus besoin.`);
        setActionValidation(() => desarchiver);
        setConfirmationOuverte(true);
    }

    const archiver = () => {
        setArchivageEnCours(true);
        AppelerApi.post('/archiver-client', { enseigne: client.ID_Enseigne }).then(() => {
            selectionnerClient(client);
            setArchivageEnCours(false);
        });
        setConfirmationOuverte(false);
    }

    const desarchiver = () => {
        setArchivageEnCours(true);
        AppelerApi.post('/desarchiver-client', { enseigne: client.ID_Enseigne }).then(() => {
            selectionnerClient(client);
            setArchivageEnCours(false);
        });
        setConfirmationOuverte(false);
    }

    const copierLienMotDePasse = () => {
        AppelerApi.get('/demander-lien-mot-de-passe', { enseigne: client.ID_Enseigne }).then(reponse => {
            navigator.clipboard.writeText(reponse);
        });
        setMessageCopie('Lien copié');
        setTimeout(() => {
            setMessageCopie('Copier dans le presse-papier');
        }, 2000);
    };

    const proposerUrlReservation = (url) => {
        url = url.trim().replace(/\s+/g, '-').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, ''); // remplace les caractères avec accents et diacritiques
        setUrlReservation(url);
        verifierUrlReservation(url);
    };

    const verifierUrlReservation = useCallback(debounce((url) => {
        AppelerApi.get('/lire-site-reservation-existe', { urlReservation: url }).then(reponse => {
            setUrlReservationInvalide(reponse.existe);
        });
    }, 500), []);

    const modifierUrlReservation = (url) => {
        url = url.trim().replace(/\s+/g, '-').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, ''); // remplace les caractères avec accents et diacritiques
        setUrlReservation(url);
        enregistrerUrlReservation(client, url);
    };

    const enregistrerUrlReservation = useCallback(debounce((client, url) => {
        AppelerApi.get('/lire-site-reservation-existe', { urlReservation: url }).then(reponse => {
            setUrlReservationInvalide(reponse.existe);
            if (!reponse.existe) {
                AppelerApi.post('/modifier-parametre-client', { idFicClient: client.idFicClient, enseigne: client.ID_Enseigne, champ: 'lsrendezvousurl', valeur: url }).then(() => {
                    setAfficherEnregistrement(true);
                });
            }
        });
    }, 500), []);

    const activerSiteDeReservation = () => {
        AppelerApi.post('/activer-site-reservation', { enseigne: client.ID_Enseigne, urlReservation }).then(() => {
            selectionnerClient(client);
            setAfficherEnregistrement(true);
        });
    };

    const ouvrirSiteDeResa = () => {
        const newTab = window.open('', '_blank');
        const url = (baseSelectionnee === 'DEV' ? `https://myresa-test.lscoiffure.app/${parametres.lsrendezvousurl}` : (parametres.marque === 2 ? `https://reservationbeaute.fr/${parametres.lsrendezvousurl}` : `https://reservationcoiffeur.fr/${parametres.lsrendezvousurl}`));
        newTab.location.href = url;
    };

    const ouvrirPageStripe = () => {
        if (!parametres.urlStripe) {
            return;
        }
        const newTab = window.open('', '_blank');
        const url = (baseSelectionnee === 'DEV' ? `https://dashboard.stripe.com/acct_1GT7hxCaccpgxVtw/test/customers/${parametres.urlStripe}` : `https://dashboard.stripe.com/acct_1GT7hxCaccpgxVtw/customers/${parametres.urlStripe}`);
        newTab.location.href = url;
    };

    const ouvrirPageCompteLemonway = () => {
        if (!parametres.idCompteLemonway) {
            return;
        }
        const newTab = window.open('', '_blank');
        const url = (baseSelectionnee === 'DEV' ? `https://sb-bo.lemonway.com/lscoiffure/accounts/${parametres.idCompteLemonway}` : `https://dashboard.lemonway.com/lscoiffure/accounts/${parametres.idCompteLemonway}`);
        newTab.location.href = url;
    };

    const ouvrirPageWalletLemonway = () => {
        if (!parametres.idWalletLemonway) {
            return;
        }
        const newTab = window.open('', '_blank');
        const url = (baseSelectionnee === 'DEV' ? `https://sb-bo.lemonway.com/lscoiffure/wallets/all` : `https://dashboard.lemonway.com/lscoiffure/wallets/all`);
        newTab.location.href = url;
    };

    const formaterDate = (date) => {
        const dateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        return dateString;
    }

    const seConnecter = (enseigne, preprod = false) => {
        const urlAppel = (baseSelectionnee === 'DEV' ? 'https://test.lscoiffure.app/lire-token-auth-salon' : (preprod ? 'https://preprod.lscoiffure.app/lire-token-auth-salon' : 'https://lscoiffure.app/lire-token-auth-salon'));
        fetch(urlAppel, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'gi7AyOmQG2njzTqxU7NOc7D'
            },
            credentials: 'include',
            mode: 'cors',
            body: JSON.stringify({ enseigne: enseigne, assistance: true })
        })
        .then(async reponse => {
            if (reponse.status >= 400) {
                return reponse.json().then(donnees => { return { codeHttp: reponse.status, ...donnees }; });
            } else {
                return reponse.json();
            }
        })
        .then(auth => {
            const newTab = window.open('', '_blank');
            if (preprod && auth.urlSalon) {
                auth.urlSalon = 'preprod.' + auth.urlSalon;
            }
            const host = (auth.urlSalon ? `https://${auth.urlSalon}` : (baseSelectionnee === 'DEV' ? 'https://test.lscoiffure.app' : (preprod ? 'https://preprod.lscoiffure.app' : 'https://lscoiffure.app')));
            const url = `${host}/login;token=${auth.token};type=salon`;
            newTab.location.href = url;
        });
    };

    const affichageDateHeure = (dateHeure) => {
        const objetDate = dateHeure ? new Date(dateHeure) : new Date();
        const date = objetDate.getDate().toString().padStart(2, '0') + '/' + (objetDate.getMonth() + 1).toString().padStart(2, '0') + '/' + objetDate.getFullYear() + ' ';
        return date + objetDate.getHours().toString().padStart(2, '0') + 'h' + objetDate.getMinutes().toString().padStart(2, '0');
    };
    dateCourante = affichageDateHeure().substring(0, 10);

    const rechercherHubspot = useCallback(debounce((nouvelleReferenceHubspot) => {
        modifierInfosNouveauClient('referenceHubspot', nouvelleReferenceHubspot);
        AppelerApi.get('/chercher-client-gomc-par-reference-hubspot', { referenceHubspot: nouvelleReferenceHubspot }).then(data => {
            if (!data) {
                return;
            }
            const donnees = {
                referenceHubspot: nouvelleReferenceHubspot,
                referenceGomc: data.referenceGomc,
                numeroMagasinGomc: data.numeroMagasinGomc,
                tvaIntracom: data.tvaIntracom,
                siret: data.siret,
                raisonSociale: data.raisonSociale,
                adresse: data.adresse,
                codePostal: data.codePostal,
                ville: data.ville,
                adresseEmail: data.adresseEmail,
                telephonePortable: mettreEnFormeTelephone(data.telephonePortable),
                telephoneSalon: mettreEnFormeTelephone(data.telephoneSalon),
            };
            modifierNouveauClient({...nouveauClient, ...donnees});
        });
    }, 500), []);

    const modifierInfosNouveauClient = (champ, valeur) => {
        const nouvelleValeur = {};
        if (champ === 'telephoneSalon' || champ === 'telephonePortable') {
            valeur = mettreEnFormeTelephone(valeur);
        }
        if (champ === 'codeNaf') {
            const metier = listeMetiers.find(metier => metier.value === valeur);
            setMetierNouveauClient(metier);
        }
        if (champ === 'statut') {
            const statut = listeStatuts.find(statut => statut.value === valeur);
            setStatutNouveauClient(statut);
        }
        nouvelleValeur[champ] = valeur;
        modifierNouveauClient({...nouveauClient, ...nouvelleValeur});
    };

    const modifierPaysNouveauClient = (idPays) => {
        const paysChoisi = PAYS.find(pays => pays.id === idPays);
        modifierInfosNouveauClient('pays', paysChoisi.id);
        modifierInfosNouveauClient('codePays', paysChoisi.code);
    };

    const enregistrerNouveauClient = () => {
        AppelerApi.post('/creer-client', nouveauClient).then(res => {
            setAfficherEnregistrement(true);
            modifierCritere(listeCriteres[1]);
            chercherSalon(listeCriteres[1], res.idFicClient, true);
            modifierNouveauClient({ telephoneSalon: '', telephonePortable: '', adresseEmail: '', nomGerant: '', raisonSociale: '', adresse: '', codePostal: '', ville: '', pays: '1', codePays: 'FR', test: false, activite: 1, siret: '', tvaIntracom: '', codeNaf: '96.02A', migrationHN: false, statut: 2 });
            passerALaCreationWebapp(res.idFicClient);
        });
        ouvrirNouveauClient(false);
    };

    const passerALaCreationWebapp = (idFicClient) => {
        localStorage.setItem('idFicClient-pour-creation-webapp', idFicClient); // bricolage mais ça marche
        const bouton = document.getElementById('bouton-creation-webapp');
        bouton.click();
    };

    const creerCommentaire = () => {
        AppelerApi.post('/creer-commentaire-assistance', { idFicClient: client.idFicClient }).then(res => {
            lireCommentairesAssistance();
            setAfficherEnregistrement(true);
        });
    };

    const enregistrerCommentaire = (nouveauCommentaire, commentaire) => {
        commentaire.contenu = nouveauCommentaire;
        AppelerApi.post('/modifier-commentaire-assistance', { id: commentaire.id, contenu: nouveauCommentaire }).then(() => {
            setAfficherEnregistrement(true);
        });
    };

    const modifierCommentaire = debounce((event, commentaire) => {
        const nouveauCommentaire = event.target.value;
        enregistrerCommentaire(nouveauCommentaire, commentaire);
    }, 500);

    const creerMateriel = () => {
        const typeMateriel = listeTypesMateriel[0]; // prendre le premier de la liste
        const nouveauMaterielParDefaut = typeMateriel.materiels[0] ?? { value: 0, label: '' };
        AppelerApi.post('/creer-materiel', { idFicClient: client.idFicClient, IDMateriel_Vendu_Type: nouveauMaterielParDefaut.value }).then(res => {
            lireMaterielClient();
            setAfficherEnregistrement(true);
        });
    };

    const enregistrerMateriel = (materiel, IDMateriel_Vendu_Type) => {
        AppelerApi.post('/modifier-materiel', { id: materiel.IDMateriel_Vendu, IDMateriel_Vendu_Type }).then(() => {
            setAfficherEnregistrement(true);
        });
    };

    /*
    const modifierTypeMateriel = debounce((event, materiel) => {
        const nouveauMateriel = event.target.value;
        enregistrerMateriel(nouveauMateriel, materiel);
    }, 500);
    */

    const lancerSuppressionMateriel = (materiel) => {
        setSupprimerMaterielOuvert(materiel.IDMateriel_Vendu);
    };

    const supprimerMateriel = () => {
        AppelerApi.post('/supprimer-materiel', { id: supprimerMaterielOuvert }).then(() => {
            setAfficherEnregistrement(true);
            masquerSupprimerMateriel();
            lireMaterielClient();
        });
    };

    const masquerSupprimerMateriel = () => {
        setSupprimerMaterielOuvert(null);
    };

    const lireTypeMateriel = (mapTypesMateriel, materiel) => {
        const typeMateriel = mapTypesMateriel[materiel.Type];
        const materielSelectionne = typeMateriel.materiels.find((mat) => mat.value === materiel.IDMateriel_Vendu_Type);
        return [typeMateriel, materielSelectionne];
    };

    const lireMaterielClient = (clientSelectionne) => {
        AppelerApi.get('/lire-materiel', { idFicClient: clientSelectionne ? clientSelectionne.idFicClient : client.idFicClient }).then(data => {
            const mapTypesMateriel = {};
            for (const typeMateriel of data.typesMateriel) {
                let type = mapTypesMateriel[typeMateriel.Type];
                if (!type) {
                    type = { value: typeMateriel.Type, label: typeMateriel.Type_Designation, materiels: [] };
                }
                type.materiels.push({ value: typeMateriel.IDMateriel_Vendu_Type, label: typeMateriel.Libelle_Materiel });
                mapTypesMateriel[type.value] = type;
            }
            setMapTypesMateriel(mapTypesMateriel);
            setListeTypesMateriel(Object.values(mapTypesMateriel));
            setMateriel(data.materiels.map((mat) => {
                const [typeMaterielSelectionne, materielSelectionne] = lireTypeMateriel(mapTypesMateriel, mat);
                mat.typeMaterielSelectionne = typeMaterielSelectionne;
                mat.materielSelectionne = materielSelectionne;
                return mat;
            }));
        });
    };

    const modifierTypeMateriel = (materiel, event) => {
        if (materiel.Type === event.value) {
            return;
        }
        const typeMateriel = mapTypesMateriel[event.value];
        const nouveauMaterielParDefaut = typeMateriel.materiels[0] ?? { value: 0, label: '' };
        setMateriel(materiels.map((mat) => {
            if (mat.IDMateriel_Vendu === materiel.IDMateriel_Vendu) {
                mat.Type = event.value;
                mat.IDMateriel_Vendu_Type = nouveauMaterielParDefaut.value;
                mat.typeMaterielSelectionne = event;
                mat.materielSelectionne = nouveauMaterielParDefaut;
            }
            return mat;
        }));
        enregistrerMateriel(materiel, nouveauMaterielParDefaut.value);
    };

    const modifierMateriel = (materiel, event) => {
        if (materiel.IDMateriel_Vendu_Type === event.value) {
            return;
        }
        setMateriel(materiels.map((mat) => {
            if (mat.IDMateriel_Vendu === materiel.IDMateriel_Vendu) {
                mat.IDMateriel_Vendu_Type = event.value;
                mat.materielSelectionne = event;
            }
            return mat;
        }));
        enregistrerMateriel(materiel, event.value);
    };

    const enregistrerTicketJira = (idTicketJira, commentaire) => {
        commentaire.contenu = idTicketJira;
        AppelerApi.post('/modifier-commentaire-assistance', { id: commentaire.id, idTicketJira: idTicketJira }).then(() => {
            setAfficherEnregistrement(true);
            lireCommentairesAssistance();
        });
    };

    const remplirTicketJira = debounce((event, commentaire) => {
        const idTicketJira = event.target.value;
        enregistrerTicketJira(idTicketJira, commentaire);
    }, 1000);

    const ouvrirTicketJira = (commentaire) => {
        if (!commentaire.idTicketJira) {
            return;
        }
        const newTab = window.open('', '_blank');
        const url = `https://hairnet.atlassian.net/browse/${commentaire.idTicketJira}`;
        newTab.location.href = url;
    };

    const annulerTicketJira = (commentaire) => {
        AppelerApi.post('/modifier-commentaire-assistance', { id: commentaire.id, idTicketJira: null }).then(() => {
            setAfficherEnregistrement(true);
            lireCommentairesAssistance();
        });
    };

    const lancerArchivageCommentaire = (commentaire) => {
        setSupprimerCommentaireOuvert(commentaire.id);
    };

    const archiverCommentaire = () => {
        AppelerApi.post('/archiver-commentaire-assistance', { id: supprimerCommentaireOuvert }).then(() => {
            setAfficherEnregistrement(true);
            masquerSupprimerCommentaire();
            lireCommentairesAssistance();
        });
    };

    const masquerSupprimerCommentaire = () => {
        setSupprimerCommentaireOuvert(null);
    };

    useEffect(() => {
        AppelerApi.get('/lire-revendeurs').then(data => {
            setRevendeurs(data.concat([nouveauRevendeur]));
        });
    }, [valeurEntree, baseSelectionnee]);

    return (
        <div className="conteneur-donneesClient">
            <h1>Données client
                {client && parametres?.idFicClient &&
                    <span className='connexion-titre'>{parametres.idFicClient}</span>
                }
                {(localStorage.getItem('Droit_Creation') === '1') && <AjouterIcone className="ajouter-client" onClick={_ => ouvrirNouveauClient(true)}/>}
                {parametres.ID_Enseigne && <ChoisirIcone className="icone connexion-titre" onClick={_ => seConnecter(parametres.ID_Enseigne)}/>}
            </h1>
            <div className="page">
                <div className="bloc-recherche">
                    <div className="recherche-client">
                        <h3>Recherche</h3>
                        <Select
                            placeholder="Critère"
                            className="selection"
                            value={critere}
                            options={listeCriteres}
                            onChange={modifierCritere}
                        />
                        { (critere.value === 'LOGIN' || critere.value === 'IDFICCLIENT' || critere.value === 'TELEPHONE'
                             || critere.value === 'NOM' || critere.value === 'RAISON_SOCIALE' || critere.value === 'EMAIL'
                             || critere.value === 'VILLE') &&
                            <TextField onChange={event => rechercheParChaine(event.target.value)} className="saisie-une-ligne"/>
                        }
                        { (critere.value === 'GROUPE') &&
                            <Select
                                className="selection"
                                options={groupes}
                                onChange={e => chercherSalon(critere, e)}
                            />
                        }
                    </div>
                    {
                    (<div className="tableau-clients"><table>
                        <thead>
                            <tr>
                                <th scope="col">Salon</th>
                                <th scope="col">Sélectionner</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(clients).map(([index, client]) =>
                                <tr key={client.idFicClient} className="ligne-activation">
                                    <td>{(client.ID_Enseigne && client.ID_Enseigne !== '') ? client.ID_Enseigne : client.idFicClient}</td>
                                    <td><ChoisirIcone className="icone" onClick={_ => selectionnerClient(client)}/></td>
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
                <div className="bloc-client">
                    {(client && parametres?.idFicClient &&
                    <div>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={ongletSelectionne} onChange={(_, index) => changerOnglet(index)}>
                                <Tab label="Données client"/>
                                <Tab label={parametres.ID_Enseigne ? 'Webapp' : 'Webapp non activée'} disabled={!parametres.ID_Enseigne}/>
                                <Tab label="Commentaires"/>
                                <Tab label="Matériel"/>
                            </Tabs>
                        </Box>
                        <div hidden={ongletSelectionne !== 0}>
                            <Box>
                                <div className="parametres">
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Référence Hubspot</label>
                                            <TextField className="saisie-une-ligne" value={parametres.Reference_Hubspot ?? ''} onChange={e => modifierParametre('Reference_Hubspot', e.target.value)}/>
                                        </div>
                                        <div className="fin-ligne">
                                            <label>Référence GOMC</label>
                                            <TextField className="saisie-une-ligne" value={parametres.Reference_GOMC ?? ''} onChange={e => modifierParametre('Reference_GOMC', e.target.value)}/>
                                        </div>
                                        <div className="saisie-magasin">
                                            <label>N° Magasin</label>
                                            <TextField className="saisie-une-ligne" value={parametres.Numero_Magasin_GOMC ?? ''} onChange={e => modifierParametre('Numero_Magasin_GOMC', e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Raison sociale</label>
                                            <TextField className="saisie-une-ligne" value={parametres.Raison_sociale ?? ''} onChange={e => modifierParametre('Raison_sociale', e.target.value)}/>
                                        </div>
                                        <div className="fin-ligne">
                                            <label>Nom de la gérante</label>
                                            <TextField className="saisie-une-ligne" value={parametres.prenom ?? ''} onChange={e => modifierParametre('prenom', e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Email du salon</label>
                                            <TextField className="saisie-une-ligne" value={parametres.adresseEmail ?? ''} onChange={e => modifierParametre('adresseEmail', e.target.value)}/>
                                            {(parametres.adresseEmail && parametres.adresseEmail !== '' &&
                                                <a href={"mailto:" + parametres.adresseEmail} className="lien-icone">
                                                    <EmailIcone className="email"/>
                                                </a>
                                            )}
                                        </div>
                                        <div className="fin-ligne">
                                            <label>Email de récupération</label>
                                            <TextField className="saisie-une-ligne" value={parametres.emailRecuperation ?? ''} onChange={e => modifierParametre('emailRecuperation', e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Téléphone portable</label>
                                            <TextField className="saisie-une-ligne" value={parametres.telephonePortable ?? ''} onChange={e => modifierTelephone('telephonePortable', e.target.value)}/>
                                            {(parametres.telephonePortable && parametres.telephonePortable !== '' &&
                                                <a href={"tel:" + parametres.telephonePortable} className="lien-icone">
                                                    <TelephoneIcone className="telephone-portable" alt={"Call " + parametres.telephonePortable} />
                                                </a>
                                            )}
                                        </div>
                                        <div className="fin-ligne">
                                            <label>Téléphone salon</label>
                                            <TextField className="saisie-une-ligne" value={parametres.telephoneSalon ?? ''} onChange={e => modifierTelephone('telephoneSalon', e.target.value)}/>
                                            {(parametres.telephoneSalon && parametres.telephoneSalon !== '' &&
                                                <a href={"tel:" + parametres.telephoneSalon} className="lien-icone">
                                                    <TelephoneIcone className="telephone-salon" alt={"Call " + parametres.telephoneSalon} />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Adresse</label>
                                            <TextField className="saisie-une-ligne" value={parametres.adresse ?? ''} onChange={e => modifierParametre('adresse', e.target.value)}/>
                                        </div>
                                        <div className="fin-ligne">
                                            <label>Pays</label>
                                            <SelectPays
                                                className="saisie-une-ligne"
                                                value={parametres.pays || "1"}
                                                onChange={e => modifierParametre('pays', e.target.value)}
                                                style={{ marginBottom: "1rem" }}
                                                defaultValue="1"
                                            />
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Code postal</label>
                                            <TextField className="saisie-une-ligne" value={parametres.codePostal ?? ''} onChange={e => modifierParametre('codePostal', e.target.value)}/>
                                        </div>
                                        <div className="fin-ligne">
                                            <label>Ville</label>
                                            <TextField className="saisie-une-ligne" value={parametres.ville ?? ''} onChange={e => modifierParametre('ville', e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Statut :</label>
                                            <Select
                                                placeholder="Statut"
                                                className="selection"
                                                value={statut}
                                                options={listeStatuts}
                                                onChange={modifierStatut}
                                            />
                                        </div>
                                        <div className="fin-ligne">
                                            <label>Métier</label>
                                            <Select
                                                placeholder="Métier"
                                                className="selection"
                                                value={metier}
                                                options={listeMetiers}
                                                onChange={modifierMetier}
                                            />
                                        </div>
                                    </div>
                                    {(parametres.ID_Enseigne &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Marque :</label>
                                                <Select
                                                    placeholder="Marque"
                                                    className="selection"
                                                    value={marque}
                                                    options={listeMarques}
                                                    onChange={modifierMarque}
                                                />
                                            </div>
                                            <div className="fin-ligne">
                                                <label>Vendu par :</label>
                                                <Select
                                                    placeholder="Revendeur"
                                                    className="selection"
                                                    value={revendeur}
                                                    options={listeRevendeurs}
                                                    onChange={modifierRevendeur}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Migration Hairnet</label>
                                            <Checkbox checked={!!parametres.Migration_HN} onChange={e => modifierParametre('Migration_HN', e.target.checked)} />
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            <label>Siret</label>
                                            <TextField className="saisie-une-ligne" value={parametres.Siret ?? ''} onChange={e => modifierParametre('Siret', e.target.value)}/>
                                        </div>
                                        <div className="fin-ligne">
                                            <label>TVA Intracommunautaire</label>
                                            <TextField className="saisie-une-ligne" value={parametres.Num_TVA_Intracom ?? ''} onChange={e => modifierParametre('Num_TVA_Intracom', e.target.value)}/>
                                        </div>
                                    </div>
                                    <div className="champ-saisie">
                                        <div className="debut-ligne">
                                            {(parametres.urlStripe && 
                                                <div className='stripe'>
                                                    Compte
                                                    <img src="stripe.svg" onClick={e => ouvrirPageStripe()}/>
                                                </div>
                                            )}
                                        </div>
                                        {(encoursClient !== null && encoursClient !== undefined &&
                                            <div className="fin-ligne">
                                                <label>Encours client GOMC</label>
                                                <div className={(encoursClient > 0 ? 'dette-client' : '')}>{encoursClient.toFixed(2)} €</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Box>
                        </div>
                        <div hidden={ongletSelectionne !== 1}>
                            <Box>
                                <div className="parametres">
                                    {(parametres.ID_Enseigne &&
                                        <Divider>WEBAPP</Divider>
                                    )}
                                    {(parametres.ID_Enseigne &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Login</label>
                                                <TextField className="saisie-une-ligne" value={parametres.ID_Enseigne ?? ''} disabled/>
                                            </div>
                                            <div className="fin-ligne">
                                                <label>Changement de mot de passe</label>
                                                <Tooltip title={messageCopie}>
                                                    <Button variant="contained" className={baseSelectionnee === 'DEV' ? 'bouton-test' : 'bouton-blanc'} onClick={copierLienMotDePasse} disabled={!parametres.ID_Enseigne || !!parametres.archive || (!parametres.archive && parametres.ticketsPresents === 0)}>
                                                        Lien
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Bloquer l'application Web</label>
                                                <Checkbox checked={parametres.bloquer} onChange={e => blocageWebApp(e.target.checked)} />
                                            </div>
                                            <div className="fin-ligne">
                                                <p>Le client {parametres.dateFin ? "a été chez nous" : "est chez nous depuis"} <span className="bold">{parametres.periodeAbonnement}</span></p>
                                            </div>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne &&
                                        <div className="boutons">
                                            <div className="champ-saisie">
                                                <label>Se connecter</label>
                                                {(baseSelectionnee === 'PROD' && localStorage.getItem('Acces_Preprod') === '1' &&
                                                    <ChoisirIcone className="icone preprod" onClick={_ => seConnecter(parametres.ID_Enseigne, true)}/>
                                                )}
                                                <ChoisirIcone className="icone" onClick={_ => seConnecter(parametres.ID_Enseigne)}/>
                                            </div>
                                            {((!parametres.archive || (!!parametres.archive && parametres.ticketsPresents > 0)) &&
                                                <div>
                                                    <Button variant="contained" className={baseSelectionnee === 'DEV' ? 'bouton-test' : 'bouton-blanc'} onClick={appelerArchiver} disabled={archivageEnCours}>
                                                        Archiver
                                                    </Button>
                                                    {(archivageEnCours &&
                                                        <p className="en-cours">...en cours</p>
                                                    )}
                                                </div>
                                            )}
                                            {((!!parametres.archive || (!parametres.archive && parametres.ticketsPresents === 0)) &&
                                                <div>
                                                    <Button variant="contained" className={baseSelectionnee === 'DEV' ? 'bouton-test' : 'bouton-blanc'} onClick={appelerDesarchiver} disabled={archivageEnCours}>
                                                        Désarchiver
                                                    </Button>
                                                    {(archivageEnCours &&
                                                        <p className="en-cours">...en cours</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <div className="champ-saisie">
                                        {(parametres.ID_Enseigne && !!parametres.admins &&
                                            <div className="debut-ligne">
                                                <label>Admin associés</label>
                                                <p>{parametres.admins}</p>
                                            </div>
                                        )}
                                        {(parametres.ID_Enseigne && !parametres.admins &&
                                            <div className="debut-ligne">
                                                <label>Aucun admin associé</label>
                                            </div>
                                        )}
                                        <div className="fin-ligne">
                                            <label>Nb de collaborateurs</label>
                                            <TextField className="saisie-une-ligne court" value={parametres.nbCollaborateurs ?? ''} disabled/>
                                        </div>
                                    </div>
                                    {(parametres.ID_Enseigne &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Dernière connexion</label>
                                                <TextField className="saisie-une-ligne court" value={parametres.dateDerniereConnexionAffiche ?? ''} disabled/>
                                            </div>
                                            <div className="fin-ligne">
                                                <label>Nb de tickets</label>
                                                <TextField className="saisie-une-ligne court" value={parametres.nbTickets ?? ''} disabled/>
                                            </div>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Fitboard</label>
                                                <Checkbox checked={!!parametres.Fitboard} onChange={e => modifierParametre('Fitboard', e.target.checked)} />
                                            </div>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne &&
                                        <Divider>SITE DE RÉSERVATION</Divider>
                                    )}
                                    {(parametres.ID_Enseigne && parametres.lsrendezvousurl && parametres.lsrendezvousurl !== '' &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Bloquer le site de réservation</label>
                                                <Checkbox checked={parametres.LSRDesactivation} onChange={e => modifierParametre('LSRDesactivation', e.target.checked)} />
                                            </div>
                                            <div className="fin-ligne">
                                                <TextField className="saisie-une-ligne modification-url" value={urlReservation} onChange={e => modifierUrlReservation(e.target.value)}/>
                                                {(!urlReservationInvalide &&
                                                    <ValideIcone className="modification-valide"/>
                                                )}
                                                {(urlReservationInvalide &&
                                                    <Tooltip title="Ce site existe déjà">
                                                        <InvalideIcone className="modification-invalide"/>
                                                    </Tooltip>
                                                )}
                                                <ChoisirIcone className="icone ouvrir-resa" onClick={ouvrirSiteDeResa}/>
                                            </div>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne && (!parametres.lsrendezvousurl || parametres.lsrendezvousurl === '') &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Activer le site de réservation</label>
                                                <TextField className="saisie-une-ligne" value={urlReservation} onChange={e => proposerUrlReservation(e.target.value)}/>
                                            </div>
                                            {(!urlReservationInvalide &&
                                                <ValideIcone className="valide"/>
                                            )}
                                            {(urlReservationInvalide &&
                                                <Tooltip title="Ce site existe déjà">
                                                    <InvalideIcone className="invalide"/>
                                                </Tooltip>
                                            )}
                                            <Button variant="contained" className={baseSelectionnee === 'DEV' ? 'bouton-test' : 'bouton-blanc'} onClick={activerSiteDeReservation} disabled={urlReservationInvalide}>
                                                Activer
                                            </Button>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne && parametres.lsrendezvousurl && parametres.lsrendezvousurl !== '' &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>Date de dernier RDV</label>
                                                <TextField className="saisie-une-ligne court" value={parametres.dateDernierRDVAffiche ?? ''} disabled/>
                                            </div>
                                            <div className="fin-ligne">
                                                <label>Activer Hairconnect</label>
                                                <Checkbox checked={!!parametres.Hairconnect} onChange={e => modifierParametre('Hairconnect', e.target.checked)} />
                                            </div>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne && parametres.lsrendezvousurl && parametres.lsrendezvousurl !== '' && parametres.Hairconnect === 1 &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                <label>ID Hairconnect</label>
                                                <TextField className="saisie-une-ligne court" value={parametres.IDHairconnect ?? ''} disabled/>
                                            </div>
                                            <div className="fin-ligne">
                                                <label>Application</label>
                                                <Select
                                                    className="selection"
                                                    value={applicationHairconnect}
                                                    options={listeApplicationsHairconnect}
                                                    onChange={modifierApplicationHairconnect}
                                                    menuPlacement={'top'}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {(parametres.ID_Enseigne && (parametres.idCompteLemonway || parametres.idWalletLemonway) &&
                                        <div className="champ-saisie">
                                            <div className="debut-ligne">
                                                {(parametres.idCompteLemonway && 
                                                    <div className='lemonway'>
                                                        Compte Lemonway
                                                        <img src="Lemonway.png" onClick={e => ouvrirPageCompteLemonway()}/>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="fin-ligne">
                                                {(parametres.idWalletLemonway && 
                                                    <div className='lemonway'>
                                                        Wallet Lemonway "{parametres.idWalletLemonway}"
                                                        <img src="Lemonway.png" onClick={e => ouvrirPageWalletLemonway()}/>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Box>
                        </div>
                        <div hidden={ongletSelectionne !== 2}>
                            <Box>
                                <div className="parametres">
                                    <table className="table-commentaires">
                                        <colgroup>
                                            <col span="1" style={{ width: '80px' }}/>
                                            <col span="1" style={{ width: '120px' }}/>
                                            <col span="1" style={{ width: 'auto' }}/>
                                            <col span="1" style={{ width: '403px' }}/>
                                            <col span="1" style={{ width: '26px' }}/>
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">Date</th>
                                                <th scope="col">Collaborateur</th>
                                                <th scope="col" colSpan={2}>Commentaire <AjouterIcone className="ajouter-commentaire" onClick={creerCommentaire}/></th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {commentaires.map((commentaire) =>
                                                <tr key={commentaire.id} className="ligne-commentaire">
                                                    <td className="commentaire-date-heure">{commentaire.dateHeureAffichee}</td>
                                                    <td>{commentaire.utilisateur}</td>
                                                    <td colSpan={((utilisateur === commentaire.utilisateur && dateCourante === commentaire.dateAffichee) || commentaire.ticketJira) ? 1 : 2}>
                                                        {utilisateur === commentaire.utilisateur && dateCourante === commentaire.dateAffichee &&
                                                            <TextareaAutosize className="saisie-commentaire" minRows={3} placeholder="Entrer le commentaire" autoComplete="off" defaultValue={commentaire.contenu} onChange={e => modifierCommentaire(e, commentaire)}/>
                                                        }
                                                        {(utilisateur !== commentaire.utilisateur || dateCourante !== commentaire.dateAffichee) &&
                                                            <div className="commentaire-contenu">{commentaire.contenu}</div>
                                                        }
                                                    </td>
                                                    {((utilisateur === commentaire.utilisateur && dateCourante === commentaire.dateAffichee) || commentaire.ticketJira) &&
                                                        <td>
                                                            {utilisateur === commentaire.utilisateur && dateCourante === commentaire.dateAffichee && !commentaire.idTicketJira &&
                                                                <TextField className="jira-saisie" placeholder="HNA-XXXXX" value={commentaire.idTicketJira} onChange={e => remplirTicketJira(e, commentaire)}/>
                                                            }
                                                            {utilisateur === commentaire.utilisateur && dateCourante === commentaire.dateAffichee && commentaire.idTicketJira &&
                                                                <AnnulerIcone className="jira-annuler" onClick={_ => annulerTicketJira(commentaire)}/>
                                                            }
                                                            {commentaire.ticketJira &&
                                                                <div className="commentaire-jira" onClick={_ => ouvrirTicketJira(commentaire)}>
                                                                    <div className="ligne-jira">{commentaire.idTicketJira + ' : ' + commentaire.ticketJira.titre}</div>
                                                                    <div className="ligne-jira">
                                                                        <span className="statut-jira" style={{backgroundColor: couleurStatut[commentaire.ticketJira.statut], border: bordureStatut[commentaire.ticketJira.statut]}}>{commentaire.ticketJira.statut}</span>
                                                                        {commentaire.ticketJira.assigne &&
                                                                            <span className="jira-assigne">chez {commentaire.ticketJira.assigne}</span>
                                                                        }
                                                                        {!commentaire.ticketJira.assigne &&
                                                                            <span>, non assigné</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }
                                                        </td>
                                                    }
                                                    <td>
                                                        {utilisateur === commentaire.utilisateur && dateCourante === commentaire.dateAffichee &&
                                                            <SupprimerIcone className="supprimer-commentaire" onClick={_ => lancerArchivageCommentaire(commentaire)}/>
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                        <div hidden={ongletSelectionne !== 3}>
                            <Box>
                                <div className="parametres">
                                    <table className="table-materiel">
                                        <colgroup>
                                            <col span="1" style={{ width: '200px' }}/>
                                            <col span="1" style={{ width: 'auto' }}/>
                                            <col span="1" style={{ width: '26px' }}/>
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">Type</th>
                                                <th scope="col">Matériel</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {materiels.map((materiel) =>
                                                <tr key={materiel.IDMateriel_Vendu} className="ligne-commentaire">
                                                    <td>
                                                        <Select
                                                            placeholder="Type"
                                                            className="selection"
                                                            value={materiel.typeMaterielSelectionne}
                                                            options={listeTypesMateriel}
                                                            onChange={e => modifierTypeMateriel(materiel, e)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Select
                                                            placeholder="Matériel"
                                                            className="selection"
                                                            value={materiel.materielSelectionne}
                                                            options={materiel.Type !== undefined && mapTypesMateriel[materiel.Type] ? mapTypesMateriel[materiel.Type].materiels : []}
                                                            onChange={e => modifierMateriel(materiel, e)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <SupprimerIcone className="supprimer-materiel" onClick={_ => lancerSuppressionMateriel(materiel)}/>
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td></td>
                                                <td><AjouterIcone className="ajouter-commentaire" onClick={creerMateriel}/></td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                        <div hidden={ongletSelectionne !== 4}>
                            <Box>
                                <div className="parametres">
                                </div>
                            </Box>
                        </div>
                    </div>
                    )}
                </div>
            </div>

            <Dialog open={confirmationOuverte} onClose={() => setConfirmationOuverte(false)}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {messageConfirmation}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(() => setConfirmationOuverte(false))} color="secondary">
                        Annuler
                    </Button>
                    <Button 
                        onClick={actionValidation}
                        color="primary">
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={nouveauRevendeurOuvert} onClose={() => setNouveauRevendeurOuvert(false)}>
                <DialogTitle>Nouveau Revendeur</DialogTitle>
                <DialogContent className={'saisie-dialog'}>
                    <TextField
                        label="Nom du revendeur"
                        name="nom"
                        value={nomRevendeur}
                        onChange={event => setNomRevendeur(event.target.value)}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={(() => setNouveauRevendeurOuvert(false))} color="secondary">
                        Annuler
                    </Button>
                    <Button 
                        onClick={creerRevendeur}
                        color="primary">
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>
            <Modal open={nouveauClientOuvert} onClose={_ => ouvrirNouveauClient(false)}>
                <Box className="pop-up">
                    <div className="parametres-nouveau-client">
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label>Référence Hubspot</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.referenceHubspot} onChange={e => rechercherHubspot(e.target.value)}/>
                            </div>
                            <div className="fin-ligne">
                                <label>Référence GOMC</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.referenceGomc} onChange={e => modifierInfosNouveauClient('referenceGomc', e.target.value)}/>
                            </div>
                            <div className="saisie-magasin">
                                <label>N° Magasin</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.numeroMagasinGomc} onChange={e => modifierInfosNouveauClient('numeroMagasinGomc', e.target.value)}/>
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label className='obligatoire'>Nom du gérant</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.nomGerant} onChange={e => modifierInfosNouveauClient('nomGerant', e.target.value)}/>
                            </div>
                            <div className="fin-ligne">
                                <label className='obligatoire'>Raison sociale</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.raisonSociale} onChange={e => modifierInfosNouveauClient('raisonSociale', e.target.value)}/>
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label className='obligatoire'>Téléphone du salon</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.telephoneSalon} onChange={e => modifierInfosNouveauClient('telephoneSalon', e.target.value)}/>
                            </div>
                            <div className="fin-ligne">
                                <label>Téléphone portable</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.telephonePortable} onChange={e => modifierInfosNouveauClient('telephonePortable', e.target.value)}/>
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label className='obligatoire'>Adresse e-mail</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.adresseEmail} onChange={e => modifierInfosNouveauClient('adresseEmail', e.target.value)}/>
                            </div>
                            <div className="fin-ligne">
                                <label className='obligatoire'>Métier</label>
                                <Select
                                    placeholder="Métier"
                                    className="selection"
                                    value={metierNouveauClient}
                                    options={listeMetiers}
                                    onChange={e => modifierInfosNouveauClient('codeNaf', e.value)}
                                />
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label className='obligatoire'>Adresse</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.adresse} onChange={e => modifierInfosNouveauClient('adresse', e.target.value)}/>
                            </div>
                            <div className="fin-ligne">
                                <label className='obligatoire'>Pays</label>
                                <SelectPays
                                    className="saisie-une-ligne"
                                    value={nouveauClient.pays}
                                    onChange={e => modifierPaysNouveauClient(e.target.value)}
                                    style={{ marginBottom: "1rem" }}
                                    defaultValue="1"
                                />
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label className='obligatoire'>Code postal</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.codePostal} onChange={e => modifierInfosNouveauClient('codePostal', e.target.value)}/>
                            </div>
                            <div className="fin-ligne">
                                <label className='obligatoire'>Ville</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.ville} onChange={e => modifierInfosNouveauClient('ville', e.target.value)}/>
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label>Siret</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.siret} onChange={e => modifierInfosNouveauClient('siret', e.target.value)}/>
                            </div>
                            <div className="fin-ligne">
                                <label>TVA Intracommunautaire</label>
                                <TextField className="saisie-une-ligne" value={nouveauClient.tvaIntracom} onChange={e => modifierInfosNouveauClient('tvaIntracom', e.target.value)}/>
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label>Statut initial :</label>
                                <Select
                                    placeholder="Statut"
                                    className="selection"
                                    value={statutNouveauClient}
                                    options={listeStatuts}
                                    onChange={e => modifierInfosNouveauClient('statut', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="champ-saisie">
                            <div className="debut-ligne">
                                <label>Migration Hairnet</label>
                                <Checkbox checked={nouveauClient.migrationHN} onChange={e => modifierInfosNouveauClient('migrationHN', e.target.checked)} />
                            </div>
                            <div className="debut-ligne">
                                <label>Compte de test</label>
                                <Checkbox checked={nouveauClient.test} onChange={e => modifierInfosNouveauClient('test', e.target.checked)} />
                            </div>
                        </div>
                    </div>
                    <div className="boutons-pop-up">
                        <Button onClick={_ => ouvrirNouveauClient(false)}>Annuler</Button>
                        <Button onClick={enregistrerNouveauClient} disabled={nouveauClient.nomGerant === '' || nouveauClient.raisonSociale === '' || nouveauClient.telephoneSalon === '' || nouveauClient.adresseEmail === '' || nouveauClient.codePostal === '' || nouveauClient.ville === '' || nouveauClient.adresse === '' || nouveauClient.codeNaf === ''}>Créer</Button>
                    </div>
                </Box>
            </Modal>
            <Modal open={!!supprimerCommentaireOuvert} onClose={masquerSupprimerCommentaire}>
                <Box className="pop-up">
                    <p>Êtes-vous sûr de vouloir archiver ce commentaire ?</p>
                    <p>L'opération ne peut être annulée que par les développeurs.</p>
                    <div className="boutons-pop-up">
                        <Button onClick={masquerSupprimerCommentaire}>Annuler</Button>
                        <Button onClick={archiverCommentaire}>Confirmer</Button>
                    </div>
                </Box>
            </Modal>
            <Modal open={!!supprimerMaterielOuvert} onClose={masquerSupprimerMateriel}>
                <Box className="pop-up">
                    <p>Êtes-vous sûr de vouloir supprimer ce matériel ?</p>
                    <p>L'opération ne peut pas être annulée.</p>
                    <div className="boutons-pop-up">
                        <Button onClick={masquerSupprimerMateriel}>Annuler</Button>
                        <Button onClick={supprimerMateriel}>Confirmer</Button>
                    </div>
                </Box>
            </Modal>
            <Snackbar className="notification" open={afficherEnregistrement} onClose={masquerEnregistrement} autoHideDuration={1500} message={'Modification enregistrée'}/>
        </div>
    );
};

export default DonneesClient;